export const ENTRY_STATUS_OPEN = 'open';
export const ENTRY_STATUS_CLOSED = 'closed';
export const ENTRY_STATUS_WAITING_LIST = 'waiting_list';
export const ENTRY_STATUS_FULL = 'full';

export const HUMAN_STATUS_INACTIVE = 'human_status_inactive';
export const HUMAN_STATUS_OPEN = 'human_status_open';
export const HUMAN_STATUS_CLOSED = 'human_status_closed';
export const HUMAN_STATUS_FULL = 'human_status_full';
export const HUMAN_STATUS_WAITING_LIST = 'human_status_waiting_list';


// WEBPACK FOOTER //
// ./src/Assets/components/RegistrationCategories/constants.js